module.exports = __webpack_public_path__ + "static/pic11.238ca9bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic11.jpg
// module id = 534
// module chunks = 247658369337294